import type { Role } from '@/types/auth'

export const ROLE_LABELS: Record<Role, string> = {
	USER: 'Usuário',
	LEADER: 'Líder',
	TECHNICIAN: 'Técnico',
	SSMA_MANAGER: 'Gestor SSMA',
	MANAGER: 'Gestor',
	ADMIN: 'Administrador',
}
